<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos los usuarios</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>
        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"> </base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="180px" prop="name" sortable>
          <template #default="{ row }">
            <span class="font-weight-bold">{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Email" min-width="180px" prop="email" sortable> </el-table-column>

        <el-table-column label="Rol" min-width="180px" prop="role" sortable>
          <template #default="{ row }">
            <span v-if="row.role">{{ row.role.label }}</span>
            <span v-else>-</span>
            <h4 v-if="row.hasRelatedRole && row.roleData">{{ row.roleData.name }}</h4>
          </template>
        </el-table-column>

        <el-table-column label="Estado" min-width="180px" prop="status" sortable>
          <template #default="{ row }">
            <badge :type="row.disabledDate ? 'danger' : row.active ? 'success' : 'warning'" class="m-1">
              {{ row.status }}
            </badge>
            <div v-if="row.disabledDate">{{ row.disabledDate | date('DD/MM/YYYY') }}</div>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="200px">
          <div slot-scope="{ row }" class="d-flex">
            <button
              v-if="$can('store', 'users')"
              :disabled="row.disabledDate"
              class="btn base-button btn-outline-info btn-sm"
              @click="inviteUser(row)"
            >
              <i class="far fa-envelope"></i>
            </button>

            <button
              v-if="$can('update', 'users')"
              :disabled="row.disabledDate"
              class="btn base-button btn-outline-primary btn-sm"
              @click="editUser(row)"
            >
              <i class="fas fa-pen"></i>
            </button>

            <div v-if="$can('update', 'users') && notHimself(row.id)">
              <button
                v-if="row.active"
                :disabled="row.disabledDate"
                class="btn base-button btn-outline-warning btn-sm mr-2"
                @click="disableUser(row)"
              >
                <i class="fas fa-user-slash"></i>
              </button>
              <button v-else class="btn base-button btn-outline-success btn-sm mr-2" @click="enableUser(row)">
                <i class="fas fa-user-shield"></i>
              </button>
            </div>

            <button
              v-if="$can('destroy', 'users') && notHimself(row.id)"
              :disabled="row.disabledDate"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteUser(row)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} usuarios</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import swal from 'sweetalert2';

export default {
  name: 'UsersTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin],
  data() {
    return {
      searchKeys: ['name', 'email', 'role.name'],
      tableData: [],
      tableName: 'UsersTable',
    };
  },

  mounted() {
    this.$services
      .resource('users')
      .get({ include: 'role', 'filter[withTrashed]': true })
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.users));
  },

  methods: {
    notHimself(userId) {
      return userId !== this.$auth.user().data.id;
    },

    deleteUser(user) {
      if (this.$can('destroy', 'users')) {
        swal({
          title: 'Se realizará la baja permanente del Usuario',
          text: '¿Desea proceder?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, dar de baja',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-secondary',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.$services
              .resource('users')
              .delete(user.id)
              .then((res) => res.data.data)
              .then((data) => {
                swal({
                  title: 'Baja realizada!',
                  text: `El usuario ${data.name} fue dado de baja.`,
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success',
                  type: 'success',
                });
                user.status = data.status;
                user.active = data.active;
                user.disabledDate = data.disabledDate;
              });
          }
        });
      }
    },

    inviteUser(user) {
      swal({
        title: 'Enviar invitación al usuario',
        text: 'Se enviará un email con los datos de acceso al sistema al mail del usuario, ¿Desea proceder?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Enviar invitación',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value) {
          this.$services
            .resource('users')
            .invite(user.id)
            .then(() => swal('Listo!', 'La invitación fue enviada.', 'success'));
        }
      });
    },

    editUser(user) {
      this.$router.push({ name: 'UserEdit', params: { id: user.id } });
    },

    enableUser(user) {
      if (this.$can('update', 'users')) {
        this.$services
          .resource('users')
          .update(user.id, { active: true })
          .then((res) => {
            swal({
              title: 'Listo!',
              text: 'El usuario fue activado.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success',
              type: 'success',
            });
            user.status = 'Activo';
            user.active = true;
          });
      }
    },

    disableUser(user) {
      if (this.$can('update', 'users')) {
        this.$services
          .resource('users')
          .update(user.id, { active: false })
          .then((res) => {
            swal({
              title: 'Listo!',
              text: 'El usuario fue desactivado.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success',
              type: 'success',
            });
            user.status = 'Inhabilitado';
            user.active = false;
          });
      }
    },
  },
};
</script>

<style scoped>
button[disabled]:hover {
  transform: none;
  box-shadow: none;
}
</style>
